import { render } from "./SingleQuestionLong.vue?vue&type=template&id=43125f7f"
import script from "./SingleQuestionLong.vue?vue&type=script&lang=js"
export * from "./SingleQuestionLong.vue?vue&type=script&lang=js"

import "./SingleQuestionLong.vue?vue&type=style&index=0&id=43125f7f&lang=css"

import exportComponent from "/Users/robert.bryden/Documents/GitHub/BreakOutTheBox/webappV2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__